<template>
    <div class="business-index">
        <!-- Dialog form lập / cập nhật đơn công tác -->
        <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog>

        <!-- Khung danh sách phiếu công tác chuẩn giao diện hệ thống -->
        <v-card class="rounded-xl elevation-3">
            <!-- Tiêu đề trang và các nút thao tác chính -->
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Phiếu công tác
                <v-spacer></v-spacer>

                <!-- Nút làm mới dữ liệu -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block
                        style="width: 40px !important; height: 40px; padding: 0px;" title="Làm mới dữ liệu">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- Nút mở form tạo mới phiếu công tác -->
                <v-btn @click="dialog.state = true" dark color="teal darken-4"
                    class="rounded-pill elevation-3 ml-4 font-weight-bold px-6">
                    <v-icon left>mdi-plus</v-icon> TẠO PHIẾU
                </v-btn>
            </v-card-title>

            <!-- BẢNG ĐIỀU KHIỂN BỘ LỌC PHÂN NHÓM THEO 3 CỘT: THỜI GIAN - THÔNG TIN PHIẾU - LOẠI & CHI TIẾT -->
            <v-sheet class="grey lighten-4 px-6 py-4">
                <v-row>
                    <!-- CỘT 1: THỜI GIAN -->
                    <v-col cols="12" md="4">
                        <div class="d-flex align-center mb-2">
                            <v-icon small color="teal darken-4" class="mr-1">mdi-calendar-clock</v-icon>
                            <span class="font-weight-bold text-caption text-uppercase teal--text text--darken-4 text-no-wrap" style="letter-spacing: 0.5px;">
                                Thời gian
                            </span>
                            <div class="flex-grow-1 ml-2" style="height: 1px; background: linear-gradient(90deg, #80cbc4 0%, rgba(207, 216, 220, 0.4) 60%, transparent 100%);"></div>
                        </div>
                        <v-row dense>
                            <!-- Tháng kỳ công -->
                            <v-col cols="12">
                                <month-picker width="100%" v-model="month" label="Tháng" outlined dense
                                    inputClass="white rounded-lg"></month-picker>
                            </v-col>
                            <!-- Khoảng ngày công tác: Từ ngày & Đến ngày -->
                            <v-col cols="6">
                                <v-text-field label="Từ ngày" type="date" clearable dense v-model="filters.from" outlined
                                    hide-details persistent-placeholder color="teal darken-4" background-color="white"
                                    class="rounded-lg"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Đến ngày" type="date" clearable dense v-model="filters.to" outlined
                                    hide-details persistent-placeholder color="teal darken-4" background-color="white"
                                    class="rounded-lg"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <!-- CỘT 2: THÔNG TIN PHIẾU -->
                    <v-col cols="12" md="4">
                        <div class="d-flex align-center mb-2">
                            <v-icon small color="teal darken-4" class="mr-1">mdi-file-document-outline</v-icon>
                            <span class="font-weight-bold text-caption text-uppercase teal--text text--darken-4 text-no-wrap" style="letter-spacing: 0.5px;">
                                Thông tin phiếu
                            </span>
                            <div class="flex-grow-1 ml-2" style="height: 1px; background: linear-gradient(90deg, #80cbc4 0%, rgba(207, 216, 220, 0.4) 60%, transparent 100%);"></div>
                        </div>
                        <v-row dense>
                            <!-- Mã phiếu và Trạng thái -->
                            <v-col cols="6">
                                <v-text-field label="Mã phiếu" placeholder="BRQ..." dense v-model="filters.code" outlined
                                    hide-details clearable prepend-inner-icon="mdi-file-document-outline" color="teal darken-4"
                                    background-color="white" class="rounded-lg"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Trạng thái" dense v-model="filters.status" outlined hide-details
                                    color="teal darken-4" background-color="white" class="rounded-lg" :items="[
                                        { text: 'Tất cả trạng thái', value: -1 },
                                        { text: 'Chờ duyệt', value: 0 },
                                        { text: 'Đã duyệt', value: 1 },
                                        { text: 'Từ chối', value: 2 },
                                    ]"></v-select>
                            </v-col>
                            <!-- Tên nhân sự và Người duyệt -->
                            <v-col cols="6">
                                <v-text-field label="Tên nhân sự" placeholder="Nhập tên..." dense
                                    v-model="filters.employeeName" outlined hide-details clearable
                                    prepend-inner-icon="mdi-account-outline" color="teal darken-4" background-color="white"
                                    class="rounded-lg"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Người duyệt" placeholder="Nhập người duyệt..." dense
                                    v-model="filters.confirmedByName" outlined hide-details clearable
                                    prepend-inner-icon="mdi-account-check-outline" color="teal darken-4" background-color="white"
                                    class="rounded-lg"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <!-- CỘT 3: LOẠI CÔNG TÁC & CHI TIẾT -->
                    <v-col cols="12" md="4">
                        <div class="d-flex align-center mb-2">
                            <v-icon small color="teal darken-4" class="mr-1">mdi-tag-multiple-outline</v-icon>
                            <span class="font-weight-bold text-caption text-uppercase teal--text text--darken-4 text-no-wrap" style="letter-spacing: 0.5px;">
                                Loại & Chi tiết
                            </span>
                            <div class="flex-grow-1 ml-2" style="height: 1px; background: linear-gradient(90deg, #80cbc4 0%, rgba(207, 216, 220, 0.4) 60%, transparent 100%);"></div>
                        </div>
                        <v-row dense>
                            <!-- Loại công tác và Số giờ -->
                            <v-col cols="7">
                                <v-autocomplete label="Loại công tác" clearable outlined dense hide-details
                                    :items="businessTypes" item-text="name" item-value="code"
                                    v-model="filters.businessTypeCode" color="teal darken-4" background-color="white"
                                    class="rounded-lg" placeholder="Chọn loại công tác"></v-autocomplete>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field label="Số giờ" placeholder="Số giờ..." dense type="number"
                                    v-model="filters.amount" outlined hide-details clearable
                                    color="teal darken-4" background-color="white" class="rounded-lg"></v-text-field>
                            </v-col>
                            <!-- Ghi chú nội dung -->
                            <v-col cols="12">
                                <v-text-field label="Ghi chú" placeholder="Tìm theo ghi chú..." dense
                                    v-model="filters.note" outlined hide-details clearable
                                    prepend-inner-icon="mdi-note-text-outline" color="teal darken-4" background-color="white"
                                    class="rounded-lg"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-sheet>

            <!-- THANH THỐNG KÊ NHANH & NÚT ĐẶT LẠI BỘ LỌC -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5 flex-wrap"
                style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0; gap: 8px;">
                <div class="subtitle-2 font-weight-bold mr-2 text-uppercase grey--text text--darken-2">Thống kê:</div>

                <!-- Thống kê tổng số phiếu -->
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="font-weight-medium" small
                    style="cursor: pointer;" @click="setStatusFilter(-1)" :outlined="filters.status === -1">
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>

                <!-- Thống kê phiếu chờ duyệt -->
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="font-weight-medium" small
                    style="cursor: pointer;" @click="setStatusFilter(0)" :outlined="filters.status === 0">
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>

                <!-- Thống kê phiếu đã duyệt -->
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small
                    style="cursor: pointer;" @click="setStatusFilter(1)" :outlined="filters.status === 1">
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Đã duyệt: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>

                <!-- Thống kê phiếu từ chối -->
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small
                    style="cursor: pointer;" @click="setStatusFilter(2)" :outlined="filters.status === 2">
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                    Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>

                <v-spacer></v-spacer>

                <!-- Nút Đặt lại bộ lọc đặt cạnh thanh thống kê -->
                <v-btn @click="resetFilters" outlined color="teal darken-4" class="rounded-pill font-weight-bold px-4"
                    small height="32">
                    <v-icon left small>mdi-filter-off-outline</v-icon> Đặt lại bộ lọc
                </v-btn>
            </v-sheet>

            <!-- BẢNG DỮ LIỆU ĐƠN ĐI CÔNG TÁC -->
            <v-data-table
                height="600px"
                fixed-header
                class="elevation-0"
                :mobile-breakpoint="0"
                :headers="headers"
                :items="items"
                :page.sync="tableParams.page"
                :sort-by.sync="tableParams.sortBy"
                :sort-desc.sync="tableParams.sortDesc"
                :server-items-length="rowCount"
                :loading="isLoading"
                loading-text="Đang tải dữ liệu..."
                :footer-props="{
                    itemsPerPageOptions: [15, 30, 50, 100]
                }"
            >
                <!-- Cột thao tác: Sửa / Thu hồi / Đã khóa -->
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex align-center justify-center text-no-wrap" v-if="!item.isLock">
                        <v-btn x-small icon color="teal darken-3" @click="editItem(item)" class="mr-1" title="Chỉnh sửa đơn">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn x-small depressed rounded color="red lighten-4" @click="deleteItem(item)"
                            class="red--text text--darken-3 font-weight-bold" title="Thu hồi đơn">
                            <v-icon left small color="red darken-3">mdi-delete</v-icon> Thu hồi
                        </v-btn>
                    </div>
                    <v-chip x-small label color="grey lighten-3" text-color="grey darken-1" v-else class="font-weight-medium">
                        <v-icon left x-small>mdi-lock</v-icon> Đã khóa
                    </v-chip>
                </template>

                <!-- Cột Mã đơn -->
                <template v-slot:[`item.code`]="{ item }">
                    <span class="font-weight-bold text-caption blue--text text--darken-3">{{ item.code }}</span>
                </template>

                <!-- Cột Trạng thái chuẩn hệ thống -->
                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="$helper.formatStatus(item.status).color" small dark
                        style="min-width: 90px; justify-content: center;" class="font-weight-medium">
                        {{ $helper.formatStatus(item.status).text }}
                    </v-chip>
                </template>

                <!-- Cột Tên nhân viên -->
                <template v-slot:[`item.employeeName`]="{ item }">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{ item.employeeName }}</div>
                    <div class="caption grey--text" v-if="item.employeeCode">{{ item.employeeCode }}</div>
                </template>

                <!-- Cột Loại công tác -->
                <template v-slot:[`item.businessTypeName`]="{ item }">
                    <span class="font-weight-medium teal--text text--darken-4">{{ item.businessTypeName }}</span>
                </template>

                <!-- Cột Ngày công tác -->
                <template v-slot:[`item.date`]="{ item }">
                    <div class="subtitle-2 font-weight-medium text-no-wrap">
                        <v-icon x-small color="teal darken-3" class="mr-1">mdi-calendar</v-icon>
                        {{ formatDate(item.date) }}
                    </div>
                </template>

                <!-- Cột Thời lượng / Số giờ -->
                <template v-slot:[`item.amount`]="{ item }">
                    <v-chip x-small outlined color="teal darken-3" class="font-weight-medium">
                        {{ formatAmount(item.amount) }}
                    </v-chip>
                </template>

                <!-- Cột Ngày gửi đơn -->
                <template v-slot:[`item.sentDate`]="{ item }">
                    <div class="caption grey--text text--darken-2 text-no-wrap" v-if="item.sentDate">
                        <v-icon x-small color="grey darken-1" class="mr-1">mdi-clock-outline</v-icon>
                        {{ formatDate(item.sentDate) }}
                    </div>
                </template>

                <!-- Cột Người duyệt -->
                <template v-slot:[`item.confirmedBy`]="{ item }">
                    <div v-if="item.confirmedBy || item.confirmedByName" class="caption grey--text text--darken-2 font-weight-medium">
                        <v-icon x-small color="grey darken-1" class="mr-1">mdi-account-check</v-icon>{{ item.confirmedBy || item.confirmedByName }}
                    </div>
                </template>

                <!-- Cột Ngày duyệt -->
                <template v-slot:[`item.confirmedDate`]="{ item }">
                    <span class="caption grey--text text--darken-1">{{ formatDate(item.confirmedDate || item.confirmDate) }}</span>
                </template>
            </v-data-table>
        </v-card>

        <!-- HỘP THOẠI XÁC NHẬN THU HỒI PHIẾU CÔNG TÁC -->
        <v-dialog v-model="dialogDelete" max-width="460px">
            <v-card class="rounded-xl">
                <v-card-title class="text-h6 font-weight-bold red--text text--darken-3 pt-4 px-6">
                    <v-icon color="red darken-3" class="mr-2">mdi-alert-circle-outline</v-icon>
                    Xác nhận thu hồi phiếu
                </v-card-title>
                <v-card-text class="px-6 py-2 text-body-1">
                    Bạn có chắc muốn thu hồi phiếu công tác <strong>{{ targetItem ? targetItem.code : '' }}</strong> không? Thao tác này không thể hoàn tác.
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="rounded-pill px-4" @click="dialogDelete = false">Hủy bỏ</v-btn>
                    <v-btn color="red darken-3" dark class="rounded-pill px-5 font-weight-bold elevation-2" @click="cfmDeleteItem">
                        Xác nhận thu hồi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as moment from "moment/moment";
import http from "@/components/services/http-common";
import Create from "./Create";

export default {
    name: "Business",
    components: {
        "create-dialog": Create,
    },
    props: ["breadcrumbs", "icon"],
    watch: {
        // Theo dõi thay đổi tham số phân trang & sắp xếp
        tableParams: {
            handler() {
                this.fetchData();
            },
            deep: true,
        },
        // Theo dõi thay đổi của các bộ lọc để tải lại dữ liệu từ trang 1
        filters: {
            handler() {
                if (this.tableParams.page === 1) {
                    this.fetchData();
                } else {
                    this.tableParams.page = 1;
                }
            },
            deep: true,
        },
        // Tự động cập nhật khoảng ngày theo tháng được chọn
        month: {
            handler(val) {
                if (val) {
                    this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                    this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
                }
            },
        },
    },

    computed: {
        // Kiểm tra quyền truy cập đặc biệt của nhân viên
        webAllowed() {
            let user = localStorage.getItem("user");
            let webAllowed = localStorage.getItem("WebAllowed");
            if (!user || !webAllowed) return false;
            try {
                user = JSON.parse(user);
                return webAllowed.includes(user.employeeCode);
            } catch (e) {
                return false;
            }
        },
        // Gom các tham số lọc và phân trang gửi lên API
        params() {
            let p = {
                ...this.tableParams,
                ...this.filters,
            };
            // Loại bỏ giá trị -1 (tất cả) để API không lọc sai
            if (p.status === -1 || p.status === null || p.status === undefined) {
                delete p.status;
            }
            // Loại bỏ các trường rỗng
            Object.keys(p).forEach(key => {
                if (p[key] === null || p[key] === undefined || p[key] === "") {
                    delete p[key];
                }
            });
            return p;
        },
        // Thống kê tổng số phiếu
        totalCount() {
            return this.rowCount || this.items.length;
        },
        // Thống kê số phiếu đang chờ duyệt
        pendingCount() {
            return this.items.filter(item => item.status === 0).length;
        },
        // Thống kê số phiếu đã duyệt
        confirmedCount() {
            return this.items.filter(item => item.status === 1).length;
        },
        // Thống kê số phiếu bị từ chối
        rejectedCount() {
            return this.items.filter(item => item.status === 2).length;
        },
    },

    data() {
        return {
            // Đường dẫn API gốc của phiếu công tác
            ROOT_URL: "BusinessRequests/",
            BUSINESSTYPE_URL: "businesstypes/",

            // Bộ lọc tháng và các tiêu chí lọc
            month: moment().format("YYYY-MM"),
            filters: {
                code: null,
                status: -1,
                employeeCode: null,
                employeeName: null,
                departmentCode: null,
                businessTypeCode: null,
                date: null,
                amount: null,
                confirmedByName: null,
                note: null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            businessTypes: [],

            // Tham số phân trang dữ liệu server-side
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            rowCount: 0,

            // Cấu hình các cột của bảng hiển thị
            headers: [
                { text: "Thao tác", value: "actions", width: "135px", sortable: false, align: "center" },
                { text: "Mã", value: "code", width: "110px", sortable: true },
                { text: "Trạng thái", value: "status", width: "130px", sortable: true, align: "center" },
                { text: "Tên nhân viên", value: "employeeName", width: "160px", sortable: true },
                { text: "Loại công tác", value: "businessTypeName", width: "180px", sortable: true },
                { text: "Ngày công tác", value: "date", width: "140px", sortable: true },
                { text: "Thời lượng", value: "amount", width: "120px", sortable: true },
                { text: "Ngày gửi", value: "sentDate", width: "130px", sortable: true },
                { text: "Người duyệt", value: "confirmedBy", width: "150px", sortable: true },
                { text: "Ngày duyệt", value: "confirmedDate", width: "130px", sortable: true },
                { text: "Ghi chú", value: "note", width: "200px", sortable: false },
            ],

            items: [],
            isLoading: true,

            // Trạng thái mở form tạo phiếu
            dialog: {
                state: false,
                item: undefined,
            },
            // Trạng thái mở dialog thu hồi phiếu
            dialogDelete: false,
            targetItem: {},
        };
    },

    methods: {
        // Định dạng hiển thị ngày DD/MM/YYYY
        formatDate(value) {
            if (!value || value === "01/01/0001" || (typeof value === "string" && value.startsWith("0001-01-01"))) return "";
            return moment(value).format("DD/MM/YYYY");
        },

        // Định dạng hiển thị số giờ / thời lượng công tác
        formatAmount(amount) {
            if (amount === 1 || amount === "1" || amount === 1.0) return "Cả ngày (1)";
            if (amount === 0.5 || amount === "0.5") return "Nửa ngày (0.5)";
            if (amount) return `${amount} giờ`;
            return "";
        },

        // Gán bộ lọc trạng thái nhanh từ thanh thống kê
        setStatusFilter(val) {
            this.filters.status = val;
        },

        // Đặt lại các giá trị của bộ lọc về mặc định
        resetFilters() {
            this.month = moment().format("YYYY-MM");
            this.filters.code = null;
            this.filters.status = -1;
            this.filters.employeeCode = null;
            this.filters.employeeName = null;
            this.filters.departmentCode = null;
            this.filters.businessTypeCode = null;
            this.filters.date = null;
            this.filters.amount = null;
            this.filters.confirmedByName = null;
            this.filters.note = null;
            this.filters.from = moment().startOf("month").format("YYYY-MM-DD");
            this.filters.to = moment().endOf("month").format("YYYY-MM-DD");
            this.tableParams.page = 1;
            this.fetchData();
        },

        // Tải danh sách đơn công tác từ API
        fetchData() {
            this.isLoading = true;
            return http.get(this.ROOT_URL, {
                params: this.params,
            })
            .then(res => {
                this.items = res.data.results || [];
                this.rowCount = res.data.rowCount || 0;
            })
            .catch(err => {
                console.error("Lỗi khi tải dữ liệu đơn công tác:", err);
            })
            .finally(() => {
                this.isLoading = false;
            });
        },

        // Tải danh mục loại công tác cho bộ lọc
        fetchBusinessType() {
            return http.get(this.BUSINESSTYPE_URL)
                .then(res => {
                    this.businessTypes = res.data.items || [];
                })
                .catch(err => {
                    console.error("Lỗi khi tải danh mục loại công tác:", err);
                });
        },

        // Đóng dialog tạo phiếu
        closeHandler() {
            this.dialog = { state: false, item: undefined };
        },

        // Chỉnh sửa đơn công tác
        editItem(item) {
            this.dialog = { state: true, item: item };
        },

        // Mở dialog xác nhận thu hồi phiếu
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },

        // Thực hiện gọi API thu hồi đơn công tác
        cfmDeleteItem() {
            if (!this.targetItem || !this.targetItem.code) return;
            return http.delete(this.ROOT_URL + this.targetItem.code)
                .then(() => {
                    this.fetchData();
                    this.dialogDelete = false;
                    this.targetItem = {};
                })
                .catch(err => {
                    console.error("Lỗi khi thu hồi đơn công tác:", err);
                    if (err.response && err.response.status === 403) {
                        if (typeof this.unauthorizeAlert === "function") {
                            this.unauthorizeAlert();
                        }
                    }
                    this.dialogDelete = false;
                });
        },
    },

    created() {
        this.fetchData();
        this.fetchBusinessType();
    },
};
</script>

<style scoped>
</style>